import { jsx as _jsx } from "react/jsx-runtime";
import styles from './skeleton.module.css';
export const Skeleton = ({ style })=>/*#__PURE__*/ _jsx("span", {
        className: styles.skeleton,
        style: style
    });
